"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createApiTransfer = createApiTransfer;
const serving_box_client_1 = require("@moojo/serving-box-client");
const axios_1 = __importStar(require("axios"));
const zod_1 = require("zod");
const ApiError = zod_1.z.object({
    errorMessage: zod_1.z.string(),
    requestId: zod_1.z.string(),
});
const maybeParseErrorAndThrow = (input) => {
    const maybeError = ApiError.safeParse(input);
    if (maybeError.success) {
        throw new serving_box_client_1.TransferError(maybeError.data.requestId, maybeError.data.errorMessage);
    }
};
const tryGetAmzRequestIdHeader = (headers) => {
    const amzReqId = headers?.['x-amzn-requestid'];
    return typeof amzReqId === 'string' ? amzReqId : undefined;
};
// TODO:
// better error handling
// api keys
function createApiTransfer(url) {
    const client = axios_1.default.create({
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return async (payload) => {
        try {
            const { data, status, headers } = await client.post(url, payload);
            if (status !== 200) {
                maybeParseErrorAndThrow(data);
                throw new serving_box_client_1.TransferError(tryGetAmzRequestIdHeader(headers), `Unknown error (status code: ${status})`);
            }
            return data;
        }
        catch (e) {
            if ((0, axios_1.isAxiosError)(e)) {
                maybeParseErrorAndThrow(e.response?.data);
                throw new serving_box_client_1.TransferError(tryGetAmzRequestIdHeader(e.response?.headers), e.message);
            }
            throw new serving_box_client_1.TransferError(undefined, `unknown error`);
        }
    };
}
//# sourceMappingURL=data:application/json;base64,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